const WEEK_LENGTH = 7;
const areNumbersConsecutive = numbers => numbers.length - 1 === numbers[numbers.length - 1] - numbers[0];

export const getConsecutiveDays = (days) => {
    const daysExtended = [...days, ...days.map(day => day + WEEK_LENGTH)];

    for (let i = 0; i < days.length; i++) {
        const daysSubArray = daysExtended.slice(i, i + days.length);

        if (areNumbersConsecutive(daysSubArray)) {
            return daysSubArray.map(dayNumber => (dayNumber > WEEK_LENGTH ? dayNumber - WEEK_LENGTH : dayNumber));
        }
    }

    return [];
};

export default getConsecutiveDays;
